import { Injectable, Inject, InjectionToken } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';

import { TokenStoreService } from './tokenstore.service';
import { Observable } from 'rxjs';

export const TokenStoreInjector = new InjectionToken('token.store.injector');

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(@Inject(TokenStoreInjector) public tokenStore: TokenStoreService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Se il token è vuoto, l'autorizzazione è già presente, o la chiamata non richiede autorizzazione,
        //   non fare nulla.
        if (
            !this.tokenStore.getToken() ||
            request.headers.has('Authorization') ||
            request.headers.has('X-Allow-Anonymous')
        ) {
            return next.handle(
                request.clone({
                    headers: request.headers.delete('X-Allow-Anonymous'),
                }),
            );
        }

        return next.handle(
            request.clone({
                setHeaders: {
                    Authorization: `Bearer ${this.tokenStore.getToken()}`,
                },
            }),
        );
    }
}
